export interface TableParam {
  page: number;
  pageSize: number;
  sortBy: string;
  orderBy: OrderBy;
  searchText: string;
  scope: string;
  specialisationId: number;
  hideResolved?: boolean | null;
  forceRefresh?: number;
}

export enum OrderBy {
  Asc = 'ASC',
  Desc = 'DESC',
}
